import React, { useState, useEffect } from 'react';
import { Icons } from './Icons';

const ImageLightbox = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [imgSrc, setImgSrc] = useState('');

    useEffect(() => {
        const handleGlobalClick = (e) => {
            // Check if the clicked element was an image
            if (e.target.tagName === 'IMG') {
                // Only expand it if it belongs to one of our target classes
                const isExpandable = 
                    e.target.classList.contains('expandable-image') || 
                    e.target.closest('.rich-text-content') || 
                    e.target.closest('.rich-text-modal') ||
                    e.target.closest('.rich-text-public');
                
                if (isExpandable) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevents modals from accidentally closing
                    setImgSrc(e.target.src);
                    setIsOpen(true);
                }
            }
        };

        // Use capture phase to intercept the click before it bubbles to other UI elements
        document.addEventListener('click', handleGlobalClick, true);
        return () => document.removeEventListener('click', handleGlobalClick, true);
    }, []);

    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 cursor-zoom-out fade-in"
            onClick={() => setIsOpen(false)}
        >
            <button className="absolute top-6 right-6 text-gray-500 hover:text-white bg-black/50 p-2 rounded-full transition-colors">
                <Icons.X size={32} />
            </button>
            <img 
                src={imgSrc} 
                className="max-w-full max-h-full object-contain shadow-2xl rounded" 
                alt="Expanded View" 
            />
        </div>
    );
};

export default ImageLightbox;